import { combinedApi as api } from "../combinedApi";
export const addTagTypes = ["MeasuringPoint"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getMeasuringPoint: build.query<
        GetMeasuringPointApiResponse,
        GetMeasuringPointApiArg
      >({
        query: () => ({ url: `/MeasuringPoint` }),
        providesTags: ["MeasuringPoint"],
      }),
      getMeasuringPointByName: build.query<
        GetMeasuringPointByNameApiResponse,
        GetMeasuringPointByNameApiArg
      >({
        query: (queryArg) => ({ url: `/MeasuringPoint/${queryArg}` }),
        providesTags: ["MeasuringPoint"],
      }),
      putMeasuringPointByName: build.mutation<
        PutMeasuringPointByNameApiResponse,
        PutMeasuringPointByNameApiArg
      >({
        query: (queryArg) => ({
          url: `/MeasuringPoint/${queryArg.name}`,
          method: "PUT",
          body: queryArg.measuringPointDto,
        }),
        invalidatesTags: ["MeasuringPoint"],
      }),
      deleteMeasuringPointByName: build.mutation<
        DeleteMeasuringPointByNameApiResponse,
        DeleteMeasuringPointByNameApiArg
      >({
        query: (queryArg) => ({
          url: `/MeasuringPoint/${queryArg}`,
          method: "DELETE",
        }),
        invalidatesTags: ["MeasuringPoint"],
      }),
      putMeasuringPointByNameTransformermodel: build.mutation<
        PutMeasuringPointByNameTransformermodelApiResponse,
        PutMeasuringPointByNameTransformermodelApiArg
      >({
        query: (queryArg) => ({
          url: `/MeasuringPoint/${queryArg.name}/transformermodel`,
          method: "PUT",
          body: queryArg.measuringPointTransformerModelDto,
        }),
        invalidatesTags: ["MeasuringPoint"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as measuringPointApi };
export type GetMeasuringPointApiResponse =
  /** status 200 OK */ MeasuringPointDto[];
export type GetMeasuringPointApiArg = void;
export type GetMeasuringPointByNameApiResponse =
  /** status 200 OK */ MeasuringPointDto;
export type GetMeasuringPointByNameApiArg = string;
export type PutMeasuringPointByNameApiResponse = /** status 200 OK */ void;
export type PutMeasuringPointByNameApiArg = {
  name: string;
  measuringPointDto: MeasuringPointDto;
};
export type DeleteMeasuringPointByNameApiResponse = unknown;
export type DeleteMeasuringPointByNameApiArg = string;
export type PutMeasuringPointByNameTransformermodelApiResponse =
  /** status 200 OK */ void;
export type PutMeasuringPointByNameTransformermodelApiArg = {
  name: string;
  measuringPointTransformerModelDto: MeasuringPointTransformerModelDto;
};
export type MeasuringPointDto = {
  name: string;
  latitude?: number;
  longitude?: number;
  switchgear: string;
  voltageLevel: string;
  currentTransformer: string;
  voltageTransformer: string;
  substation: string;
  comment?: string | null;
  hasData: boolean;
  isUsed: boolean;
  wasEverUsed: boolean;
  transformerModelVoltageL1?: number | null;
  transformerModelVoltageL2?: number | null;
  transformerModelVoltageL3?: number | null;
  transformerModelCurrentL1?: number | null;
  transformerModelCurrentL2?: number | null;
  transformerModelCurrentL3?: number | null;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export type MeasuringPointTransformerModelDto = {
  name: string;
  transformerModelVoltageL1?: number | null;
  transformerModelVoltageL2?: number | null;
  transformerModelVoltageL3?: number | null;
  transformerModelCurrentL1?: number | null;
  transformerModelCurrentL2?: number | null;
  transformerModelCurrentL3?: number | null;
};
export const {
  useGetMeasuringPointQuery,
  useLazyGetMeasuringPointQuery,
  useGetMeasuringPointByNameQuery,
  useLazyGetMeasuringPointByNameQuery,
  usePutMeasuringPointByNameMutation,
  useDeleteMeasuringPointByNameMutation,
  usePutMeasuringPointByNameTransformermodelMutation,
} = injectedRtkApi;
